import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import LaboratoryRequestTemplateSelection from './LaboratoryRequestTemplateSelection';
import { LaboratoryRequisitionTemplate } from '../../../../../graphql/graphql';

interface Props extends BaseModalProps {
	workplaceId: string;
	doctorId: string;
	formId: string;
	onSelect: (item: LaboratoryRequisitionTemplate) => void;
}

const LaboratoryRequestTemplateSelectionModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.laboratoryRequestTemplateSelection.modalTitle'>
			<LaboratoryRequestTemplateSelection
				workplaceId={props.workplaceId}
				doctorId={props.doctorId}
				formId={props.formId}
				onSelect={props.onSelect}
			/>
		</BaseModal>
	);
};
export default LaboratoryRequestTemplateSelectionModal;
